<template>
  <div>
    <p>redirecting...</p>
  </div>
</template>

<script>
export default {
  name: 'Callback',

  async created() {
    try {
      await this.$sso.exchangeToken(this.$route.query)

      const user = this.$sso.decodeUser()
      this.$store.set('sso/user', user)
      this.$sso.setDistrictId(user, this.$store)

      this.$router.push('/')
    } catch (error) {
      console.log(error)
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Ahh yes är fixat nu. Tog första bästa av 4,5,17 alltså alltid 4 som default. Men borde tagit första bästa som är valid av alla distrikt man har! -->
